module.exports = __webpack_public_path__ + "static/avatar-7d3851e7a8560f8533af79dbb7642fde.jpg";